import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { WideTableDemo } from '../operations/WideTableDemo';
import { Code } from './Section';
export function WideTablePatternTile() {
  return (
    <div
      data-slot="wide-table-pattern-tile"
      className="min-w-0 overflow-hidden rounded-lg border border-line bg-card"
    >
      <header className="flex flex-wrap items-center gap-4 border-b border-line p-5">
        <div className="min-w-0 flex-1">
          <h3 className="type-heading">Широкая таблица</h3>
          <p className="mt-1 text-sm text-fg-muted">
            Закреплённые названия и итоги, следующие колонки той же формы. Прокрутка мышью и клавиатурой, с
            сохранением места.
          </p>
        </div>
        <Link
          to="/design/operations?demo=table"
          className="inline-flex h-9 items-center gap-2 rounded-md border border-line bg-muted px-3 text-xs font-semibold text-fg hover:bg-hover focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"
        >
          Открыть образец
          <ArrowRight className="size-4" />
        </Link>
      </header>
      <div className="min-w-0 p-5">
        <WideTableDemo memoryScope="kaname.gallery.wide-table.v1" />
      </div>
      <p className="border-t border-line p-4">
        <Code>WideTable · WideColumn · Table · Skeleton · useScrollMemory</Code>
      </p>
    </div>
  );
}
